export default __webpack_public_path__ + "static/media/9.176eb1d6.jpg";